export default __webpack_public_path__ + "static/media/rabbit-red.fa22ad13.png";